// Import packages
import React, { Component } from "react";
import { connect } from "react-redux";
import Nestable from "react-nestable";

// Import components
import { NestableItem } from "../../components/cards/nestableItem";
import PageWrapper from "../../components/pageContentViews/pageWrapper";
import PageHeader from "../../components/pageContentViews/pageHeader";

// Import utils
import { mapStateToProps } from "../../redux/mapStateToProps";
import { changeStateField, deleteItem } from "../../utils/helperFunctions";
import {
    GetPartners,
    DeletePartnerById,
    UpdatePartnersPositions,
    GetPartnerRequests,
    DeletePartnerRequestById,
} from "../../redux/actions";
import { CustomTabs } from "../../components/uiElements/Tabs";
import ItemsList from "../../components/ItemsList";

const pageTabs = [
    {
        name: "Գործընկերներ",
        key: "partner"
    },
    {
        name: "Հայտեր",
        key: "request"
    },
]

class Partner extends Component {
    constructor (props) {
        super(props);
        this.state = {
            activeTab: pageTabs[0].key,
        }
        this.changeTab = changeStateField.bind(this, "activeTab");
        this.deleteSlider = deleteItem.bind(this, props.DeletePartnerById, 'գործընկերոջը');
        this.onPositionChange = this.onPositionChange.bind(this);
    }

    componentDidMount () {
        this.props.GetPartners();
        this.props.GetPartnerRequests();
    }


    getNestableItems (list, parent = null) {
        const items = [];
        list && !!list.length && list.forEach((item, index) => {

            items.push({
                id: item.id,
                index: index,
                title: ' ',
                withImage: true,
                isHidden: item.isHidden,
                path: item?.mediaMain?.path,
                link: {
                    pathname: `partners/edit/${item.id}`,
                },
                deleteCb: () => this.deleteSlider(item.id),
                children: []
            })
        });
        return items;
    }

    async onPositionChange (items, item) {
        const movedSliderId = item.id;
        const { partnersList } = this.props;
        const positionedItems = items.map((item, index) => {
            return { id: item.id, position: index }
        });
        if (~partnersList.findIndex(m => m.id === movedSliderId) &&
            ~positionedItems.findIndex(m => m.id === movedSliderId)) {
            // first level menu was re-positioned in first level
            await this.props.UpdatePartnersPositions(positionedItems);
            this.props.GetPartners();
        }
    }

    render () {
        let { activeTab } = this.state;
        let { partnersList, partnerRequests } = this.props;
        let items = this.getNestableItems(partnersList);

        let itemListHeaderInfo = {
            generalInfo: ["Անուն", "Ազգանուն", "Էլ․ հասցե", "Հեռ․ համար",],
            actions: ["delete"],
        };
        let itemListInfo = partnerRequests?.map((request) => {
            const {id, firstname, lastname, phone, email} = request;
            return {
                id,
                values: [
                    firstname ?? '-',
                    lastname ?? '-',
                    email ?? '-',
                    phone ?? '-',
                ],
                deleteCb: deleteItem.bind(this, this.props.DeletePartnerRequestById, 'Հայտը', id)
            }
        });
        return <PageWrapper pageTitle={'Գործընկերներ'}>
            <PageHeader linkTitle={"Ավելացնել"}
                        addingLink={"/partners/add"}/>
            <CustomTabs changeTab={this.changeTab}
                        tabsList={pageTabs}
                        activeTab={activeTab}/>
            {activeTab === pageTabs[0].key && items && items.length !== 0 &&
            <Nestable
                items={items}
                maxDepth={1}
                onChange={this.onPositionChange}
                renderItem={NestableItem}
            />}
            {activeTab === pageTabs[1].key && items && items.length !== 0 &&
            <ItemsList itemListHeaderInfo={itemListHeaderInfo}
                       itemListInfo={itemListInfo}/>}
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetPartners,
    GetPartnerRequests,
    DeletePartnerRequestById,
    DeletePartnerById,
    UpdatePartnersPositions
};

export default connect(mapStateToProps, mapDispatchToProps)(Partner);
